var classifier = angular.module('classifier', ['commons.app']);